<template>
  <div>
    <el-dialog
      title="充值过滤次数"
      :visible.sync="visible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="dataForm"
        :rules="rules"
        ref="dataForm"
        label-width="100px"
      >
        <el-form-item label="次数" prop="TotalCount">
          <el-input
            v-model="dataForm.TotalCount"
            placeholder="请输入次数"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="TotalAmount">
          <el-input
            v-model="dataForm.TotalAmount"
            placeholder="请输入金额"
            type="number"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="confirmLoading" @click="ok"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      dataForm: {
        CustomerId: "",
        TotalCount: "", //次数
        TotalAmount: "", //金额
      },
      rules: {
        TotalCount: {
          required: true,
          message: "请输入次数",
          trigger: "change",
        },
        TotalAmount: {
          required: true,
          message: "请输入金额",
          trigger: "change",
        },
      },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.dataForm.CustomerId = id;
    },
    handleClose() {
      this.$refs.dataForm.resetFields();
      this.visible = false;
      this.dataForm.Id = "";
    },
    ok() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: "/api/CustomerCompany/PostRecharge",
            method: "post",
            data: this.dataForm,
          })
            .then((res) => {
              if (res.data && res.data.success) {
                this.confirmLoading = false;
                this.$message.success(res.data.msg || '操作成功');
                this.handleClose();
                this.$emit("ok");
              }
            })
            .finally(() => (this.confirmLoading = false));
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>